import React, { useRef, useEffect } from 'react';
import './Joints.scss';
import videomov from '../../../../assets/contemporary/joints/contemporary_joints_mobile.mov';
import video from '../../../../assets/contemporary/joints/contemporary_joints_mobile.webm';
import poster from '../../../../assets/contemporary/joints/contemporary_joints_mobile_poster.png';
import videomovD from '../../../../assets/contemporary/joints/contemporary_joints_desktop.mov';
import videoD from '../../../../assets/contemporary/joints/contemporary_joints_desktop.webm';
import posterD from '../../../../assets/contemporary/joints/contemporary_joints_desktop_poster.png';

function ContemporaryJoints({ screenWidth }) {
  const videoDRef = useRef();
  const videoMRef = useRef();
  const jointsRef = useRef();
  const copyDRef = useRef();
  const copyMRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            if (entry['intersectionRatio'] > 0.6) {
              if (screenWidth > 480) {
                videoDRef.current.play();
                copyDRef.current.style.opacity = 1;
              } else {
                videoMRef.current.play();
                copyMRef.current.style.opacity = 1;
              }
            }
          }
        });
      },
      { threshold: [0, 0.6] }
    );
    observer.observe(jointsRef.current);
  }, [screenWidth]);

  return (
    <section className="joints joints-contemporary">
      <div className="joints__text joints__text-contemporary">
        <h3 className="joints__text__title joints__title__copy-contemporary">
          Spacesuits are pressurized to protect wearers from the vacuum of space. Because of this,
          astronauts have to work hard just to move around.
        </h3>
      </div>
      <div className="joints__lower joints__lower-contemporary">
        <div className="joints__animation joints__animation-contemporary" ref={jointsRef}>
          <video
            muted={true}
            playsInline
            preload="auto"
            ref={videoDRef}
            className="joints__animation__video joints__animation__video-desktop"
            poster={posterD}
          >
            <source src={videomovD} type="video/quicktime" />
            <source src={videoD} type="video/webm" />
          </video>

          <video
            muted={true}
            playsInline
            preload="auto"
            ref={videoMRef}
            className="joints__animation__video joints__animation__video-mobile"
            poster={poster}
          >
            <source src={videomov} type="video/quicktime" />
            <source src={video} type="video/webm" />
          </video>

          <p
            className="joints__animation__copy joints__animation__copy-contemporary joints__animation__copy-mobile"
            ref={copyMRef}
          >
            Joint alignment between an astronaut and her suit is vital to conserve energy and
            prevent injury.
          </p>
        </div>
        <p
          className="joints__animation__copy joints__animation__copy-contemporary joints__animation__copy-desktop"
          ref={copyDRef}
        >
          Joint alignment between an astronaut and her suit is vital to conserve energy and prevent
          injury.
        </p>
      </div>
    </section>
  );
}

export default ContemporaryJoints;
